import { render, staticRenderFns } from "./products-search-results-item-column.vue?vue&type=template&id=0195c30c&"
import script from "./products-search-results-item-column.vue?vue&type=script&lang=js&"
export * from "./products-search-results-item-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports